import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Stack, Typography } from '@mui/material';
import { useAuth } from '../../hooks/useAuth';
import { adminShellBackgroundSx } from './adminVisuals';
import { adminLoginPath } from '../../config/adminPath';

export default function ProtectedRoute() {
  const location = useLocation();
  const { isConfigured, isLoading, isCheckingAccess, user, adminProfile, adminAccessStatus, adminAccessError, signOut } =
    useAuth();

  if (!isConfigured) {
    return (
      <Box sx={{ ...adminShellBackgroundSx, display: 'grid', placeItems: 'center', px: 2, py: 6 }}>
        <Stack spacing={2} sx={{ width: '100%', maxWidth: 560 }}>
          <Typography variant="h4" fontWeight={900} sx={{ color: '#16324f' }}>
            Painel indisponível
          </Typography>
          <Alert severity="warning">O acesso ao painel ainda não foi liberado neste ambiente.</Alert>
        </Stack>
      </Box>
    );
  }

  if (isLoading || (isCheckingAccess && !adminProfile && adminAccessStatus !== 'authorized')) {
    return (
      <Box sx={{ ...adminShellBackgroundSx, display: 'grid', placeItems: 'center', px: 2 }}>
        <Stack alignItems="center" spacing={2}>
          <CircularProgress />
          <Typography color="text.secondary">Preparando o painel...</Typography>
        </Stack>
      </Box>
    );
  }

  if (adminAccessStatus === 'fallback') {
    return (
      <Box sx={{ ...adminShellBackgroundSx, display: 'grid', placeItems: 'center', px: 2, py: 6 }}>
        <Stack spacing={2} sx={{ width: '100%', maxWidth: 580 }}>
          <Typography variant="h4" fontWeight={900} sx={{ color: '#16324f' }}>
            Painel temporariamente indisponível
          </Typography>
          <Alert severity="warning">
            {adminAccessError || 'Não foi possível confirmar sua sessão administrativa no servidor.'}
          </Alert>
        </Stack>
      </Box>
    );
  }

  if (adminAccessStatus === 'denied') {
    return (
      <Box sx={{ ...adminShellBackgroundSx, display: 'grid', placeItems: 'center', px: 2, py: 6 }}>
        <Stack spacing={2} sx={{ width: '100%', maxWidth: 580 }}>
          <Typography variant="h4" fontWeight={900} sx={{ color: '#16324f' }}>
            Acesso administrativo bloqueado
          </Typography>
          <Alert severity="error">
            {adminAccessError || 'Seu usuário autenticou, mas não possui acesso administrativo ativo.'}
          </Alert>
          <Button
            variant="contained"
            onClick={() => {
              void signOut();
            }}
            sx={{ alignSelf: 'flex-start', borderRadius: 999 }}
          >
            Sair
          </Button>
        </Stack>
      </Box>
    );
  }

  if (!user || adminAccessStatus !== 'authorized') {
    return <Navigate to={adminLoginPath} replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
